import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {ISharedLoadingG} from '../../../../models/animations';
import {getDeepCopyOfObject} from '../../../../../shared-utils/object/object.utils';
import {AnimationLoadingGNameEnum} from '../../../../models/animations/animation-name.enum';

@Component({
    selector: 'app-shared-loading-g',
    templateUrl: './shared-loading-g.component.html',
    styleUrls: ['./shared-loading-g.component.scss'],
    standalone: false
})
export class SharedLoadingGComponent {

  #animated: ISharedLoadingG = undefined;

  @ViewChild('svgContainer', {static: true}) svgContainer!: ElementRef;

  get animation(): ISharedLoadingG {
    return this.#animated;
  }

  @Input() set animation(animate: ISharedLoadingG) {
    this.getPathLength(getDeepCopyOfObject(animate), '.animation-path');
  }

  private getPathLength(animation: ISharedLoadingG, querySelector: string): void {
    const paths = this.svgContainer.nativeElement.querySelectorAll(querySelector);
    paths.forEach((path: SVGPathElement) => {
      const length = path.getTotalLength();
      if (path.id === 'topSection' &&
        animation.topSection &&
        (animation.topSection.animation === AnimationLoadingGNameEnum.DRAW_ONCE_NEON_FLASH ||
          animation.topSection.animation === AnimationLoadingGNameEnum.DRAW_ONCE ||
          animation.topSection.animation === AnimationLoadingGNameEnum.DRAW_REVERSE_ONCE)) {
        animation.topSection.strokeDashArray = `${length}`;
        animation.topSection.strokeDashOffset = `${length}`;
      }
      if (path.id === 'bottomSection' &&
        animation.bottomSection &&
        (animation.bottomSection.animation === AnimationLoadingGNameEnum.DRAW_ONCE_NEON_FLASH ||
          animation.bottomSection.animation === AnimationLoadingGNameEnum.DRAW_ONCE ||
          animation.bottomSection.animation === AnimationLoadingGNameEnum.DRAW_REVERSE_ONCE)) {
        animation.bottomSection.strokeDashArray = `${length}`;
        animation.bottomSection.strokeDashOffset = `${length}`;
      }
      if (path.id === 'topSection'
        && (animation.topSection.animation === AnimationLoadingGNameEnum.DASH_RUNNER ||
          animation.topSection.animation === AnimationLoadingGNameEnum.DASH_RUNNER_NEON)) {
        const segment = length * 0.1;
        const gap = length - segment;
        path.style.strokeDasharray = `${segment} ${gap}`;
        path.style.strokeDashoffset = '0';
        animation.topSection.strokeDashArray = `${segment} ${gap}`;
        animation.topSection.strokeDashOffset = `0`;
        animation.topSection.strokeDashOffsetEnd = `-${length}`;
      }
      if (path.id === 'bottomSection'
        && (animation.bottomSection.animation === AnimationLoadingGNameEnum.DASH_RUNNER ||
          animation.bottomSection.animation === AnimationLoadingGNameEnum.DASH_RUNNER_NEON)) {
        const segment = length * 0.1;
        const gap = length - segment;
        path.style.strokeDasharray = `${segment} ${gap}`;
        path.style.strokeDashoffset = '0';
        animation.bottomSection.strokeDashArray = `${segment} ${gap}`;
        animation.bottomSection.strokeDashOffset = `0`;
        animation.bottomSection.strokeDashOffsetEnd = `-${length}`;
      }
    });
    this.#animated = animation;
  }

}
